import fs from 'fs';
import path from 'path';
const ffmpeg = require('fluent-ffmpeg');
const ffmpegPath = require('ffmpeg-static-electron').path;
import { delOtherPCM } from './util';
import { app} from 'electron';
import log from 'electron-log';

let outputFilePath = process.env.NODE_ENV === 'development' ? path.resolve(__dirname, '../../dist') : path.join(app.getPath('userData'), 'ffmpeg');
const resolve = (file: string) => path.resolve(outputFilePath, file);

let ffmpegCommandList: any [] = []
let timer: NodeJS.Timeout

// 删除之前的文件
export const ffmpegDelFile = () => {
  timer && clearTimeout(timer)
  delOtherPCM(outputFilePath);
  killFfmpeg()
}

// 杀掉未完成的进程
export const killFfmpeg = () => {
  log.info('ffmpegCommandList killFfmpeg',ffmpegCommandList.length)
  // log.info('ffmpegCommandList killFfmpeg',ffmpegCommandList.length)
  ffmpegCommandList && ffmpegCommandList.forEach(command => {
    try {
      log.info('ffmpegCommand kill')
      command.kill('SIGKILL')
    } catch (error) {
      log.error('kill error',error)
    }
  })
  ffmpegCommandList = []
}


// 保存成文件
export const ffmpegSaveFile = (callback: (type: string, errObj?: {errMsg: string, stdout: string, stderr: string }) => void, audioList: {audioId?: string | number, audioMd5?: string, audioUrl: string} [] ) => {
  log.info('audioList',audioList)

  try {
    const outputExist = fs.existsSync(outputFilePath);
    if (!outputExist) {
      fs.mkdirSync(outputFilePath);
    }

    audioList && audioList.forEach(item => {
      const filePath = resolve(`${item.audioMd5}.pcm`);
      const fileExist = fs.existsSync(filePath);
      log.info('item.audioId1',fileExist,item.audioMd5)

      // 判断文件是否存在，存在的话不要继续转换
      if (fileExist) {
        return false;
      }

      log.info('item.audioId2',item.audioMd5)
      let progressTimer: NodeJS.Timeout;
      const ffmpegCommand = ffmpeg(item.audioUrl)
        .renice(20)
        .setFfmpegPath(ffmpegPath)
        .format('s16le')
        .audioCodec('pcm_s16le')
        .audioFrequency(16000)
        .audioChannels(1)
        .save(filePath)

        ffmpegCommand.on('start', function (commandLine: string) {
          ffmpegCommandList.push(ffmpegCommand)
          log.info('ffmpegCommandList start',ffmpegCommandList.length, commandLine)
        })
        .on('error', function (err: {message: string}, stdout: string, stderr: string) {
          progressTimer && clearTimeout(progressTimer)
          // 非这个原因kill的，再回调
          if (err.message.indexOf('ffmpeg was killed with signal') === -1) {
            callback('error', { errMsg: err.message, stdout, stderr })
          }
          log.error('ffmpeg error: ' + err.message,item.audioMd5);
        })
        .on('progress', function (progress: {percent: number}) {
          if (progress.percent > 90) {
            ffmpegEndHandle('progress', callback, progressTimer, ffmpegCommand)
          }
          progressTimer && clearTimeout(progressTimer)
          progressTimer = setTimeout(() => {
            ffmpegCommand.kill('SIGKILL')
            ffmpegSaveFile(callback, [item])
            log.error('ffmpegCommand.kill progressTimer: ' + item.audioMd5 + ',' + progressTimer);
          }, 10 * 1000);
          log.info('successss Processing: ' + item.audioMd5 + ',' + progress.percent + '% done');
        })
        .on('end', function () {
          ffmpegEndHandle('end', callback, progressTimer, ffmpegCommand)
          log.info('successss ffmpeg end ffmpegSaveFile Processing: ', item.audioMd5)
        })
        .run();
    });
  } catch (error) {
    log.error('ffmpeg save error:', error);
  }
}

const ffmpegEndHandle = (type: string, callback: (type: string, errObj?: {errMsg: string, stdout: string, stderr: string }) => void, progressTimer: NodeJS.Timeout, ffmpegCommand: any) => {
  callback(type)
  progressTimer && clearTimeout(progressTimer)
  const dellIndex = ffmpegCommandList.indexOf(ffmpegCommand)
  if (dellIndex > -1) {
    ffmpegCommandList.splice(dellIndex, 1)
  }
  log.info('ffmpegCommandList', type, ffmpegCommandList.length)

}

// 读取之前存的文件
export const ffmpegReadFile = (callback: (chunk: number | string) => void, id: number) => {
  const filePath = resolve(`${id}.pcm`);

  fs.exists(filePath, (exists: boolean) => {
    log.info('ffmpegReadFile ffmpegReadFile', exists)
    if (exists) {
      log.info('ffmpegReadFile exists', exists)
      fs.readFile(filePath, (err, chunk) => {
        chunk && callback(chunk.splice(5120));
      });
    } else {
      timer && clearTimeout(timer)
      timer = setTimeout(() => {
        log.info('ffmpegReadFile setTimeout', exists)
        ffmpegReadFile(callback, id)
      }, 500);
    }
  })
}

export const ffmpegCommand = (callback: (chunk: number | string) => void, url: string) => {
  const rand = Math.random();
  const _outputFilePath = resolve(`${rand}.pcm`);

  if (!url) {
    return
  }
  var command = ffmpeg(url)
    .renice(20)
    .setFfmpegPath(ffmpegPath)
    .format('s16le')
    .audioCodec('pcm_s16le')
    .audioFrequency(16000)
    .audioChannels(1)
    .save(_outputFilePath)
    .on('start', function (commandLine: string) {
      log.info('ffmpeg commandLine: ' + commandLine);
    })
    .on('error', function (err: {message: string}, stdout: string, stderr: string) {
      log.error('ffmpeg error: ' + err.message, stdout, stderr);
    })
    .on('end', function () {
      log.info('ffmpeg end [' + new Date() + '] Video Pushing is Finished !');
      setTimeout(() => {
        fs.readFile(_outputFilePath, (err, chunk) => {
          chunk && callback(chunk.splice(5120));
        });
      }, 500);

    });
  return command;

};

Buffer.prototype.splice =
  Buffer.prototype.splice ||
  function (num: number) {
    let arr = [];
    let cur = 0;
    let n = 0;
    while ((n = n + num) <= this.length) {
      arr.push(this.slice(cur, n).toString('base64'));
      cur = n;
    }
    arr.push(this.slice(cur).toString('base64'));
    return arr;
  };

